import { Theme, Typography, useTheme } from "@material-ui/core";
import { BluetoothAudio, BluetoothDisabled, Help } from "@material-ui/icons";
import { memo } from "react";

interface Props {
  eldConnected?: boolean | null;
}

export const VehicleStatusHeader = memo(({ eldConnected }: Props) => {
  const theme = useTheme<Theme>();
  return (
    <div className="info-window-content-header">
      <div className="header-info">
        <div>
          <Typography variant="body2">ELD connection</Typography>
        </div>
        <div>
          {eldConnected ? (
            <Typography variant="body2">
              <BluetoothAudio
                fontSize="small"
                style={{ color: theme.palette.success.main }}
              />
            </Typography>
          ) : eldConnected === null ? (
            <Typography variant="body2">
              <Help
                fontSize="small"
                style={{ color: theme.palette.warning.main }}
              />
            </Typography>
          ) : (
            <Typography variant="body2">
              <BluetoothDisabled
                fontSize="small"
                style={{ color: theme.palette.error.main }}
              />
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
});
